import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../css/dataTablePopUp.css';
import '../css/sqlEditorPopUp.css';
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
} from 'reactflow';
import Select from "react-select";

import {
  showCatalogSchemas, showCatalogSchemasTables, showCatalogSchemasTablesColumns
} from '../authorization/FetchToken';

import Spinner from '../Spinner'; // Import the Spinner component
import SearchableDropdown from '../SearchableDropdown';


const SqlEditorPopupComponent = ({ onClose, onRemoveTable, selectedNodeId, onValueSubmit,
  nodes, setNodes, droppedNodes, setDroppedNodes,
  nodeName,
  data, rightListValue, leftListValue, catalogList, schemasList,
  tableList, columnList, columnTypeList, initialCatalog, initialTable,
  initialCatalogList, initialSchemaList,
  initialTableList, initialColumnList, sqlTextValue,
  selectedFieldsFromEditorValue,
  editorCatalogValue,
  editorSchemaValue,
  editorTableValue
}) => {
  console.log(JSON.stringify(sqlTextValue) + "sqlTextValue");
  console.log(JSON.stringify(rightListValue) + "rightListValue");
  console.log(JSON.stringify(rightListValue) + "rightListValue");
  console.log(JSON.stringify(catalogList) + "catalogList");
  console.log(JSON.stringify(schemasList) + "schemasList");
  console.log(JSON.stringify(tableList) + "tableList");
  console.log(JSON.stringify(columnList) + "columnList");
  // console.log(JSON.stringify(columnList.map(column => column[0])) + "columnList");
  console.log(JSON.stringify(initialTable) + "initialTable");
  console.log(JSON.stringify(columnTypeList) + "columnTypeList");
  console.log(JSON.stringify(selectedFieldsFromEditorValue) + "selectedFieldsFromEditorValue");

  const windowFunctions = [
    // { value: '', label: 'Select a window function' },
    { value: 'ROW_NUMBER', label: 'ROW_NUMBER()' },
    { value: 'RANK', label: 'RANK()' },
    { value: 'DENSE_RANK', label: 'DENSE_RANK()' },
    { value: 'NTILE', label: 'NTILE()' },
    { value: 'MIN', label: 'MIN()' },
    { value: 'MAX', label: 'MAX()' },
    { value: 'SUM', label: 'SUM()' },
    { value: 'COUNT', label: 'COUNT()' },
    { value: 'AVG', label: 'AVG()' },
    { value: 'LEAD', label: 'LEAD()' },
    { value: 'LAG', label: 'LAG()' },
    { value: 'PERCENTAGE_COUNT', label: 'PERCENTAGE_COUNT' },
    { value: 'PERCENTAGE_SUM', label: 'PERCENTAGE_SUM' },
    { value: `date_format(date, '%d') AS date`, label: 'FORMAT_DATE_DAY' },
    { value: `date_format(date, '%M') AS month_name`, label: 'FORMAT_DATE_MONTH' },
    { value: `date_format(date, '%Y') AS year`, label: 'FORMAT_DATE_YEAR' },
    { value: "ROUND", label: 'ROUND' }

    // Add more window functions as needed
  ];
  useEffect(() => {
    if (catalogList.length > 0) {
      setCatalog(catalogList.map(catalog => catalog[0])); // Assuming catalogList is a two-dimensional array
    }
  }, [catalogList]);

  useEffect(() => {
    if (schemasList.length > 0) {
      setSelectedDatabase(schemasList.map(schema => schema[0]));
    }
  }, [schemasList]);

  useEffect(() => {
    if (tableList.length > 0) {
      setSelectedTable(tableList.map(table => table[0]));
    }
  }, [tableList]);

  useEffect(() => {
    if (columnList.length > 0) {

      //  const columnNames = columnList.map(column => column[0]);
      // setSelectedTableColumns(columnList[0]);

    }
  }, [columnList]);

  const [catalogDataList, setCatalogDataList] = useState(catalogList.length > 0 ? catalogList : []);
  const [schemaDataList, setSchemaDataList] = useState(schemasList.length > 0 ? schemasList : []);
  const [tableDataList, setTableDataList] = useState(tableList.length > 0 ? tableList : []);
  const [columnDataList, setColumnDataList] = useState(columnList.length > 0 ? columnList : []);
  const [columnTypeListValue, setColumnTypeListValue] = useState(columnTypeList.length > 0 ? columnTypeList : []);


  //alert(JSON.stringify(leftListValue)+"leftListValue");
  const [name, setName] = useState(nodeName);
  const [catalog, setCatalog] = useState(initialCatalog || (catalogList.length > 0 ? catalogList[0] : []));
  console.log(JSON.stringify(catalog) + "catalog");
  const [selectedDatabase, setSelectedDatabase] = useState(schemasList.length > 0 ? schemasList[0][0] : []);
  console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
  const [selectedTable, setSelectedTable] = useState(initialTable || tableList.length > 0 ? tableList[0][0] : []);
  console.log(JSON.stringify(selectedTable) + "selectedTable");

  const [leftList, setLeftList] = useState(
    leftListValue && leftListValue.length > 0 ? leftListValue : columnList.length > 0 ? columnList : []);
  console.log(JSON.stringify(leftList) + "leftList");
  const [rightList, setRightList] = useState(
    rightListValue && rightListValue.length > 0 ? rightListValue : columnTypeList.length > 0 ? columnTypeList.map(type => type[1]) : []
  );

  //SQL EDITOR

  const [text, setText] = useState(sqlTextValue || '');
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [selectedText, setSelectedText] = useState(sqlTextValue || '');
  const [selectedStart, setSelectedStart] = useState(null);
  const [selectedEnd, setSelectedEnd] = useState(null);

  const [selectedFieldsFromEditor, setSelectedFieldsFromEditor] = useState(selectedFieldsFromEditorValue &&
    selectedFieldsFromEditorValue.length > 0 ? selectedFieldsFromEditorValue : []);
  const [editorCatalog, setEditorCatalog] = useState(editorCatalogValue || '');
  const [editorSchema, setEditorSchema] = useState(editorSchemaValue || '');
  const [editorTable, setEditorTable] = useState(editorTableValue || '');
  const [selectedFields, setSelectedFields] = useState([]);

  const [highlightedText, setHighlightedText] = useState(''); // State for highlighted text


  useEffect(() => {

    setName(nodeName);
    setCatalog(catalog);
    setSelectedDatabase(selectedDatabase);
    setSelectedTable(selectedTable);
    setText(text);
    setLeftList(leftList);
    setRightList(rightList);
    // setSelectedFieldsFromEditor(selectedFieldsFromEditor);
    // setSelectedTableColumns(selectedTableColumns);
    // Find the selected node based on the selectedNodeId

    const selectedNode = nodes.find((node) => node.id === selectedNodeId);
    console.log(JSON.stringify(selectedNode) + "selectedNode");
    if (selectedNode) {
      // Update the selectedDatabase and selectedTable states based on the selected node's values
      setCatalog(selectedNode.data.catalog);
      setSelectedDatabase(selectedNode.data.selectedDatabase);
      setSelectedTable(selectedNode.data.selectedTable);
      setSelectedFieldsFromEditor(selectedNode.data.selectedFieldsFromEditorValue);
      setEditorCatalog(selectedNode.data.editorCatalogValue);
      setEditorSchema(selectedNode.data.editorSchemaValue);
      setEditorTable(selectedNode.data.editorTableValue);


    }
    // setRightList(rightList);
    // setLeftList(leftList);

    // if (rightListValue && rightListValue.length > 0) {
    //   console.log(JSON.stringify(rightListValue) + "rightListValue");
    //   const formattedRightList = rightListValue.map((column) => {
    //     const columnName = column.split('.').pop().replace(')', '');
    //     return columnName;
    //   });

    //   setRightList(formattedRightList);

    //   console.log(JSON.stringify(leftListValue) + "leftListValue");
    //   setLeftList(leftList);

    // } else {
    //   setRightList([]);
    // }
    // if (leftListValue && leftListValue.length > 0) {
    //   setLeftList(leftList);
    // } else if (leftListValue && leftListValue.length === 0) {
    //   setLeftList([]);
    // } else {
    //   setLeftList(columnList || []);
    // }



  }, [nodeName], [text], [selectedNodeId], [nodes], [rightList], [leftList]);



  // cataloglist


  const [schemas, setSchemas] = useState([]);
  const [loading, setLoading] = useState(false);

  const renderCatalogsOptions = () => {
    return catalogList.map((catalog, index) => (
      <option key={index} value={catalog}>
        {catalog}
      </option>
    ));
  };

  const renderSchemasOptions = () => {
    return schemaDataList.map((schema, index) => (
      <option key={index} value={schema}>
        {schema}
      </option>
    ));
  };

  const renderTable1Options = () => {
    return tableDataList.map((table, index) => (
      <option key={index} value={table}>
        {table}
      </option>
    ));
  };

  const renderColumnOptions = () => {
    return columnList.map((column, index) => (
      <option key={index} value={column}>
        {column}
      </option>
    ));
  };



  const handleCatalogChange = async (event) => {
    const catalog = event.target.value;

    let response = null;
    setLoading(true);
    try {
      response = await showCatalogSchemas(catalog);
      console.log(JSON.stringify(response[0][0]) + "response");
      if (response && response.length > 0) {
        setSelectedDatabase(response[0][0]);
        setSchemaDataList(response.map(schema => schema[0]));

        const catalogSchemaName = `${catalog}.${response[0][0]}`;

        const tables = await showCatalogSchemasTables(catalogSchemaName);
        if (tables && tables.length > 0) {
          console.log(JSON.stringify(tables[0][0]) + "tables");
          setSelectedTable(tables[0][0]);
          setTableDataList(tables.map(table => table[0]));

          const catalogSchemaTableName = `${catalogSchemaName}.${tables[0][0]}`;

          // `${catalogs[0][0]}.${schemas[0][0]}`

          try {
            const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
            console.log(JSON.stringify(response[0][0]) + "columnname");
            if (response && response.length > 0) {
              setLeftList(response.map(leftList => leftList[0]));
              setColumnDataList(response.map(leftList => leftList[0]));

              setRightList(response.map(leftList => leftList[1]));
              // setSelectedTableColumns(response[0][0]);

              setColumnTypeListValue(response);
            }
          } catch (error) {
            console.error('Error fetching dropdown options:', error);
          }

        }


      }
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
    console.log(JSON.stringify(response) + "list of schemas");
    setCatalog(catalog);
    setLoading(false);
  };


  const handleDatabaseChange = async (event) => {
    const schema = event.target.value;
    // const selectedDatabase = data.databases.find(
    //   (database) => database.name === selectedDatabaseName
    // );
    setLoading(true);
    setCatalog(catalog);
    setSelectedDatabase(schema);
    const catalogSchemaName = `${catalog}.${schema}`;

    try {
      const response = await showCatalogSchemasTables(catalogSchemaName);
      console.log(JSON.stringify(response) + "response");
      if (response && response.length > 0) {
        setSelectedTable(response[0][0]);
        setTableDataList(response.map(table => table[0]));

        const catalogSchemaTableName = `${catalog}.${schema}.${response[0][0]}`;
        // `${catalogs[0][0]}.${schemas[0][0]}`
        try {
          const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
          console.log(JSON.stringify(response[0][0]) + "response");
          if (response && response.length > 0) {
            setLeftList(response.map(leftList => leftList[0]));
            setColumnDataList(response.map(column => column[0]));


            setLeftList(response.map(leftList => leftList[0]));

            setRightList(response.map(leftList => leftList[1]));

            setColumnTypeListValue(response);


          }
        } catch (error) {
          console.error('Error fetching dropdown options:', error);
        }

      }
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
    setLoading(false);
  };


  const handleTableChange = async (event, selectedTable) => {
    const selectedTableName = event.target.value;
    setLoading(true);
    setSelectedTable(selectedTableName);


    // if (selectedTable) {
    const catalogSchemaTableName = `${catalog}.${selectedDatabase}.${selectedTableName}`;
    try {
      const response = await showCatalogSchemasTablesColumns(catalogSchemaTableName);
      console.log(JSON.stringify(response[0]) + "response");
      if (response && response.length > 0) {
        setSelectedTable(selectedTableName);
        setLeftList(response.map(column => column[0]));
        setColumnDataList(response.map(column => column[0]));

        setRightList(response.map(leftList => leftList[1]));

        setColumnTypeListValue(response);

      }
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
    }
    setLoading(false);

  };




  console.log(selectedNodeId + "selectedNodeId");


  const handleNodesUpdate = () => {
    const updatedNodes = [...nodes]; // Create a copy of the nodes array
    // Update the nodes array as needed
    // ...

    setNodes(updatedNodes); // Call the setNodes function to update the nodes in the parent component
  };

  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    //onClose(nodes)
  };


  function parseSelectedFields(sqlTextValue) {
    let selectedFieldsArray = [];

    // Extract selected fields using regular expression and case-insensitivity
    const selectMatch = sqlTextValue.match(/SELECT/i);
    const fromMatch = sqlTextValue.match(/FROM/i);

    if (selectMatch && fromMatch) {
      const selectIndex = selectMatch.index;
      const fromIndex = fromMatch.index;

      const selectedFields = sqlTextValue.substring(selectIndex + 6, fromIndex).trim(); // 6 is the length of "SELECT"

      // Split the selectedFieldsPart by commas, considering AS for aliases
      selectedFieldsArray = selectedFields.split(',').map(field => {
        // Split the field by 'AS' to separate field name and alias
        const fieldParts = field.split('AS').map(part => part.trim());

        // Use the field name as the selected field (with AS alias if present)
        return fieldParts.length > 1 ? fieldParts[1] : fieldParts[0];
      });
    }

    return selectedFieldsArray;
  }


  const handleSubmit = (event) => {

    let aliasColumnNames = '';
    let aliasFunctionNames = '';

    console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
    console.log(JSON.stringify(selectedTable) + "selectedTable");
    // console.log(JSON.stringify(selectedTableColumns) + "selectedTableColumns");
    console.log(JSON.stringify(catalog) + "catalog");
    console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
    console.log(JSON.stringify(selectedTable) + "selectedTable");
    const formattedRightList = rightList.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
    const formattedLeftList = leftList.map((column) => `${catalog}.${selectedDatabase}.${selectedTable}.${column}`);
    console.log(JSON.stringify(schemaDataList) + "schemaDataList");


    //console.log(JSON.stringify(formattedRightListOne)+"formattedRightList1");
    console.log(JSON.stringify(formattedRightList) + "formattedRightList");
    console.log(selectedText + "----------------");


    const selectedFieldsArray = parseSelectedFields(selectedText);
    console.log('Selected Fields:', selectedFieldsArray);
    // Extract catalog, database, and table from the query
    const { editorCatalog, editorSchema, editorTable } = extractCatalogSchemaTable(text);
    console.log(selectedFieldsFromEditor + "selectedFieldsFromEditor");
    // Update state variables for catalog, database, and table
    setEditorCatalog(editorCatalog);
    setEditorSchema(editorSchema);
    setEditorTable(editorTable);
    //setSelectedFields(selectedFieldsArray);
    setSelectedFieldsFromEditor(selectedFieldsArray);

    onValueSubmit(selectedNodeId, name, catalog, selectedDatabase, selectedTable,
      columnDataList, leftList, rightList,

      catalogDataList, schemaDataList,
      tableDataList, columnDataList, initialCatalogList, initialSchemaList,
      initialTableList, initialColumnList, columnTypeListValue,
      text, selectedText, selectedFieldsFromEditor, editorCatalog, editorSchema, editorTable
    );


  };


  const [dynamicValue, setDynamicValue] = useState('');

  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);
  };

  const onDragStart = (event, column) => {

    event.dataTransfer.setData('application/reactflow', JSON.stringify(column));
    event.dataTransfer.effectAllowed = 'move';
  };
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const handleAddAll = () => {
    setRightList((prevRightList) => [...prevRightList, ...leftList]);
    setLeftList([]);
  };
  const handleRemoveAll = () => {
    setLeftList((prevLeftList) => [...prevLeftList, ...rightList]);
    setRightList([]);
  };


  const handleDeleteColumn = (columnId) => {
    setRightList((columns) => columns.filter((column) => column !== columnId));
    setLeftList((columns) => {
      const existingColumn = rightList.find((column) => column === columnId);
      if (!existingColumn) {
        return [...columns];
      }
      return [...columns, existingColumn];
    });
  };

  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const reactFlowWrapper = useRef(null);

  const onDrop = useCallback(
    (event, list) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const typeData = event.dataTransfer.getData('application/reactflow');
      const type = JSON.parse(typeData);

      if (!type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });


      if (list === 'left' && !leftList.find((column) => column === type)) {
        setRightList((columns) => columns.filter((column) => column !== type));
        setLeftList((columns) => [...columns, type]);
      }

      if (list === 'right' && !rightList.find((column) => column === type)) {
        setLeftList((columns) => columns.filter((column) => column !== type));
        setRightList((columns) => [...columns, type]);


      }
    },
    [reactFlowInstance, leftList, rightList]
  );


  const handleRefreshTables = (event) => {
    console.log(JSON.stringify(catalogList) + "--"
      + JSON.stringify(schemasList) + "--" +
      JSON.stringify(tableList) + "--" +
      JSON.stringify(columnList));
    setCatalogDataList(catalogList);
    setSchemaDataList(schemasList);
    setTableDataList(tableList);
    setColumnDataList(columnList);

    setCatalog(catalogList[0]);
    setSelectedDatabase(schemasList[0]);
    //setSelectedTable(selectedDatabase.tables[0]);
    const selectedTable = tableList[0]; // Change this logic based on your requirements
    setSelectedTable(selectedTable);

    console.log(JSON.stringify(selectedTable) + "selectedTableselectedTable");

    if (selectedTable) {

      setLeftList(columnList);

      setRightList([]);
      //  setSelectedTableColumns(columnList[0]);
      // setOrderBy(columnList[0]);

    }
  };

  const toggleBold = () => {
    setIsBold(!isBold);
  };

  const toggleItalic = () => {
    setIsItalic(!isItalic);
  };

  const toggleUnderline = () => {
    setIsUnderline(!isUnderline);
  };
  // const handleTextareaSelect = (e) => {
  //   const selectedStart = e.target.selectionStart;
  //   const selectedEnd = e.target.selectionEnd;
  //   const selected = text.substring(selectedStart, selectedEnd);
  //   setSelectedText(selected);
  //   setSelectedStart(selectedStart);
  //   setSelectedEnd(selectedEnd);
  // };

  const handleTextareaSelect = (e) => {
    const selectedStart = e.target.selectionStart;
    const selectedEnd = e.target.selectionEnd;

    // Extract the selected text
    const textBeforeSelection = text.substring(0, selectedStart);
    const selectedText = text.substring(selectedStart, selectedEnd);
    const textAfterSelection = text.substring(selectedEnd);

    // Wrap the selected text in a span with a CSS class
    const highlightedText = (
      <span className="highlighted">{selectedText}</span>
    );

    // Combine the text before, highlighted text, and text after
    const newText = textBeforeSelection + highlightedText + textAfterSelection;

    // Update the textarea value
    // setText(newText);
    setSelectedText(selectedText);
  };


  // const handleTextareaSelect = (e) => {
  //   const selectedStart = e.target.selectionStart;
  //   const selectedEnd = e.target.selectionEnd;

  //   if (selectedStart === selectedEnd) {
  //     // No text is selected
  //     setSelectedText('');
  //   } else {
  //     const selected = text.substring(selectedStart, selectedEnd);

  //     setSelectedText(selected);
  //   }

  //   setSelectedStart(selectedStart);
  //   setSelectedEnd(selectedEnd);
  // };



  const getHighlightedText = (text, start, end) => {
    if (start !== null && end !== null) {
      return (
        <>
          {text.substring(0, start)}
          <span className="highlighted">{text.substring(start, end)}</span>
          {text.substring(end)}
        </>
      );
    }
    return text;
  };

  const extractCatalogSchemaTable = (query) => {


    // Use a regular expression to match the part after 'FROM' but before the next space
    const fromRegex = /FROM\s+([^\s]+)/i;
    const fromRegexMatch = query.match(fromRegex);

    if (fromRegexMatch) {
      // Get the part before 'from' and trim any leading/trailing whitespace
      const afterFrom = fromRegexMatch[1].trim();

      // Split the 'beforeFrom' part by dots to get catalog, database, and table names
      const [editorCatalog, editorSchema, editorTable] = afterFrom.split('.').map(part => part.trim());

      return {
        editorCatalog,
        editorSchema,
        editorTable,

      };
    } else {
      console.error('Invalid query format');
      return {
        editorCatalog: '',
        editorSchema: '',
        editorTable: ''
      };
    }
  };

  const handleQueryChange = (e) => {
    const query = e.target.value;
    setText(query); // Update the SQL query state

    let selectedFieldsArray = [];
    // Extract selected fields using regular expression and case-insensitivity
    const selectMatch = query.match(/SELECT/i);
    const fromMatch = query.match(/FROM/i);

    if (selectMatch && fromMatch) {
      const selectIndex = selectMatch.index;
      const fromIndex = fromMatch.index;

      const selectedFields = query.substring(selectIndex + 6, fromIndex).trim(); // 6 is the length of "SELECT"
      //  const selectedFieldsArray = selectedFields.split(',').map(field => field.trim());

      // Split the selectedFieldsPart by commas, considering AS for aliases
      selectedFieldsArray = selectedFields.split(',').map(field => {
        // Split the field by 'AS' to separate field name and alias
        const fieldParts = field.split('AS').map(part => part.trim());

        // Use the field name as the selected field (with AS alias if present)
        return fieldParts.length > 1 ? fieldParts[1] : fieldParts[0];
      });

      console.log('Selected Fields:', selectedFieldsArray);


      setSelectedFieldsFromEditor(selectedFieldsArray);
    }


    // Extract catalog, database, and table from the query
    const { editorCatalog, editorSchema, editorTable } = extractCatalogSchemaTable(query);
    // Update state variables for catalog, database, and table
    // console.log(JSON.stringify(selectedFieldsFromEditor)+"selectedFieldsFromEditor");
    setEditorCatalog(editorCatalog);
    setEditorSchema(editorSchema);
    setEditorTable(editorTable);

  };

  return (
    <div className="overlay">

      <div className="popup-datatable">
        {loading && (
          <div className="overlay">
            <div className="loading-container">
              <Spinner />
              <p className="please-wait">Please wait...</p>
            </div>
          </div>
        )}
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name</label>
              <input type="text" value={name}
                className="form-control" onChange={handleNameChange}
                id="textbox" />
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">List of Catalogs </label>


              <select id="database" className="form-control"
                value={catalog}
                onChange={handleCatalogChange}
              >
                {renderCatalogsOptions()}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="dropdown">List of Database </label>


              <select id="database" className="form-control"
                value={selectedDatabase}
                onChange={handleDatabaseChange}
              >

                {/* {renderDatabaseOptions()}  */}
                {renderSchemasOptions()}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="dropdown">List of Table</label>

              <select id="table" className="form-control" value={selectedTable}
                onChange={(event) => handleTableChange(event, selectedTable)}

              >
                {renderTable1Options()}
              </select>

            </div>
            <button type='button' className='btn btn-primary'
              onClick={() => handleRefreshTables()}>REFRESH TABLES</button>
          </div>

          <div className="list-container">


            <div className="leftlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'left')} >

              <ul>

                {leftList.map((column) => (
                  <li
                    key={column}
                    className="blockItem ui-draggable"
                    draggable
                    onDragStart={(event) => onDragStart(event, column)}
                  >
                    {column}
                  </li>
                ))}

              </ul>
            </div>

            <ReactFlowProvider>
              <div className="" ref={reactFlowWrapper}>
                <ReactFlow
                  onInit={setReactFlowInstance}
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                  fitView
                >
                  <Controls />
                </ReactFlow>
              </div>
            </ReactFlowProvider>
            <div className="rightlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'right')}>

              <ul>
                {rightList.map((column) => (
                  <li key={column} className="blockItem ui-draggable" draggable
                    onDragStart={(event) => onDragStart(event, column)}>
                    {column}

                    <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>
                  </li>

                ))}
              </ul>
            </div>

          </div>
          {/* )} */}


          <div className="add-remove">
            <button type="button" className="btn btn-add" onClick={handleAddAll}>
              Add All
            </button>


            <button type="button" className="btn btn-removeall" onClick={handleRemoveAll}>
              Remove All
            </button>
          </div>


          <div className="editor">
            <div className="editor-container">
              <div className="editor-toolbar">
                <button type="button" onClick={toggleBold}>Bold</button>
                <button type="button" onClick={toggleItalic}>Italic</button>
                <button type="button" onClick={toggleUnderline}>Underline</button>
              </div>
              <textarea
                id="editor"
                rows="10"
                cols="50"
                defaultValue={getHighlightedText(text, selectedStart, selectedEnd)}
                //  value={text}
                placeholder="Enter your SQL query here"
                onChange={handleQueryChange}
                // onChange={(e) => setText(e.target.value)}
                onSelect={handleTextareaSelect}
                // onFocus={() => setHighlightedText('')} // Clear highlighted text when focusing
                style={{
                  fontWeight: isBold ? 'bold' : 'normal',
                  fontStyle: isItalic ? 'italic' : 'normal',
                  textDecoration: isUnderline ? 'underline' : 'none',

                }}
              >
                {/* {highlightedText ? (
          <span className="highlighted">{highlightedText}</span>
        ) : null} */}

              </textarea>
              {/* <style>
                {`
          .highlighted {
            background-color: yellow;
          }
        `}
              </style> */}
            </div>
          </div>

          {/* <div className="slide-toggle-div">
            <div className="slide-toggle-button" onClick={toggleDropdowns}>
              <span>SELECT WINDOW FUNCTIONS</span>
            </div>
          </div>
          */}



          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Delete Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={handleSubmit} >OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SqlEditorPopupComponent;
